<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="betsList"
        :search="search"
        class="elevation-1 pb-3"
        :loading="loading"
        :loading-text="$t('loadingData')"
        :no-data-text="$t('noDataText')"
        :no-results-text="$t('noResultsText')"
        :items-per-page="100"
        hide-default-footer
      >
        <template v-slot:top>
          <div class="row no-gutters d-flex align-center pa-3">
            <!-- <div class="d-flex align-center" v-if="betsList.length > 0">
              <v-icon left>mdi-account-multiple</v-icon>
              <span>{{ totalPlayers }}</span>

              <span class="ml-2">
                {{ $tc("usersPlurals", totalPlayers) }}
              </span>

              <v-progress-circular
                v-if="fetchingPlayers"
                indeterminate
                :size="20"
                color="primary"
                class="ml-2"
              ></v-progress-circular>
            </div> -->
            <v-spacer />
            <v-col cols="12" md="4" sm="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </div>
        </template>
  
        <template v-slot:[`item.player_id`]="{ item }">
          <v-btn @click="$copy(item.player_id)" x-small>
            {{ item.player_id }}
          </v-btn>
        </template>

        <template v-slot:[`item.player_name`]="{ item }">
          {{ maskLastNames(item.player_name) }}
        </template>

        <template v-slot:[`item.bet_id`]="{ item }">
          <v-btn @click="$copy(item.bet_id)" x-small>
            {{ item.bet_id }}
          </v-btn>
        </template>

        <template v-slot:[`item.bet_value`]="{ item }">
          <div :class="getClassByValue('bet_value', item.bet_value)">
            {{ item.bet_value || "0.00" }}
          </div>
        </template>

        <template v-slot:[`item.bet_multiplier`]="{ item }">
          <div :class="getClassByValue('bet_multiplier', item.bet_multiplier)">
            {{ item.bet_multiplier || "0.00" }}
          </div>
        </template>

        <template v-slot:[`item.bet_prize`]="{ item }">
          <div :class="getClassByValue('bet_prize', item.bet_prize)">
            {{ item.bet_prize || "0.00" }}
          </div>
        </template>

        <template v-slot:[`item.bet_events_qty`]="{ item }">
          <div class="text-end">
            {{ item.bet_events_qty }}
          </div>
        </template>

        <template v-slot:[`item.date_register`]="{ item }">
          {{ handleDateFormat(item.date_register).date }}
        </template>
        
        <template v-slot:[`item.bet_result`]="{ item }">
          <v-chip small :color="handleResult(item.bet_result).color">
            {{ handleResult(item.bet_result).text}}
          </v-chip>
        </template>
  
        <template v-slot:[`item.consult_date`]="{ item }">
          {{ handleDateFormat(item.consult_date).date }}
        </template>

        <template v-slot:[`item.bet_date`]="{ item }">
          {{ handleDateFormat(item.bet_date).date }}
        </template>

        <template v-slot:[`item.bet_time`]="{ item }">
          {{ handleDateFormat(item.bet_date).hour }}
        </template>

        <template v-slot:[`item.bet_result_date`]="{ item }">
          {{ handleDateFormat(item.bet_result_date).date }}
        </template>

        <template v-slot:[`item.bet_cancel_date`]="{ item }">
          {{ handleDateFormat(item.bet_cancel_date).date }}
        </template>
      </v-data-table>
      <v-pagination
        v-if="pageCount > 0"
        v-model="page"
        :length="pageCount"
        :total-visible="7"
        class="pb-3"
      ></v-pagination>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "relatorio-apostas",
  data: (vm) => ({
    loading: false,
    fetchingPlayers: false,
    page: 1,
    pageCount: 0,
    timeoutId: 0,
    latestRangeDate: {},
    cachedPage: {},
    search: "",
    totalPlayers: 0,
    headers: [
      { text: "ID", value: "player_id", align: "no-wrap" },
      { text: vm.$t("name"), value: "player_name", align: "no-wrap" },
      { text: vm.$t("registration"), value: "date_register", align: "no-wrap" },
      { text: "DDD", value: "ddd", align: "no-wrap" },
      { text: vm.$t("idBet"), value: "bet_id", align: "no-wrap" },
      { text: vm.$t("bet"), value: "bet_value", align: "no-wrap" },
      { text: vm.$t("multiplier"), value: "bet_multiplier", align: "no-wrap" },
      { text: vm.$t("infoPrizeValue"), value: "bet_prize", align: "no-wrap" },
      { text: vm.$t("result"), value: "bet_result", align: "no-wrap" },
      { text: "Status", value: "bet_status", align: "no-wrap" },
      { text: vm.$t("type"), value: "bet_type", align: "no-wrap" },
      { text: vm.$t("eventNumber"), value: "bet_events_qty", align: "no-wrap" },
      { text: vm.$t("betDate"), value: "bet_date", align: "no-wrap" },
      { text: vm.$t("resultDate"), value: "bet_result_date", align: "no-wrap" },
      { text: vm.$t("cancellation"), value: "bet_cancel_date", align: "no-wrap" },
    ],
    betsList: [],
    routeName: "",
  }),

  computed: {
    rangeDate() {
      let { date_start, date_final } = this.$store.state.rangeGlobal.date;
      return { data_inicio: date_start, data_final: date_final };
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    rangeDateHasChanged() {
      if (!this.latestRangeDate.data_inicio) return false;
      return this.latestRangeDate.data_inicio != this.rangeDate.data_inicio ||
        this.latestRangeDate.data_final != this.rangeDate.data_final
    }
  },

  watch: {
    saveFilters(bool) {
      bool && this.fetchBetsReport();
    },
    page() {
      this.fetchBetsReport(true);
    },
  },

  mounted() {
    this.routeName = this.$route.name;
  },

  methods: {
    async fetchBetsReport(isChangingPage) {
      if (isChangingPage) {
        this.$store.commit("setGroupExport", "")
      }
      const body = {
        ...this.rangeDate,
        export: this.exportDoc,
      }

      if (this.exportDoc && !isChangingPage) {
        await this.$exportDocument(
          "agent/players/sportsBettingReport",
          body,
          this.exportDoc,
          this.rangeDate,
          this.routeName
        );
        return
      }

      body.page_number = this.page - 1;
      this.loading = true;
      this.betsList = []

      if (this.cachedPage[this.page] && !this.rangeDateHasChanged) {
        this.betsList = this.cachedPage[this.page]
        this.loading = false;
        this.$store.commit("setFeedbackProgress", false);
        this.$store.commit("setProgressLinear", false);
        this.$store.commit("setSave", false);
        this.$store.commit("DisabledSave", false);
        return
      }

      await this.$request
        .post("agent/players/sportsBettingReport", body)
        .then((resp) => {
          this.betsList = resp.data.dados;
          if (this.betsList.length == 100) {
            if (this.rangeDateHasChanged) {
              this.pageCount = 2;
              this.page = 1;
            } else {
              if (this.pageCount == 0) {
                this.pageCount = 2
              } else {
                this.pageCount += 1
              }
            }
          }
          this.cachedPage[this.page] = this.betsList;
          this.loading = false;
          this.latestRangeDate = {...this.rangeDate}
        })
        .catch(() => this.loading = false);
    },

    handleDateFormat(dateAndHour) {
      if (dateAndHour == null) {
        return { 
          date: "-",
          hour: "-"
        };
      } else {
        return { 
          date: new Date(dateAndHour).toLocaleDateString(),
          hour: new Date(dateAndHour).toLocaleTimeString()
        };
      }
    },

    handleResult(string) {
      if (string == this.$t("betStatus.Pending")) return { text: this.$t("betStatus.Pending"), color: 'grey'};
      if (string == this.$t("betStatus.Lost")) return { text: this.$t("betStatus.Lost"), color: "green"};
      if (string == this.$t("betStatus.Awarded")) return { text: this.$t("betStatus.Awarded"), color: "red"};
      if (string == this.$t("betStatus.Cashout")) return { text: this.$t("betStatus.Cashout"), color: "warning"};
      return {}
    },

    getClassByValue(string, value) {
      let num = Number(value);
      const map = {
        bet_value: "green--text",
        bet_multiplier: "orange--text",
        bet_prize: "red--text"
      };

      return num > 0 ? `${map[string]} text-end` : "grey--text text-end";
    },

    maskLastNames(fullName) {
      let words = fullName.split(' ');
      if (words.length > 1) {
        let firstName = words[0];

        let maskedLastNames = words.slice(1).map(lastName => 
          lastName.replace(/./g, '*')
        );

        return [firstName, ...maskedLastNames].join(' ');
      } else {
        return fullName;
      }
    }
  }
}
</script>